import { useState } from "react";

import "./MyFleetPage.scss";

import MyFleetTable from "../../components/MyFleetTable/MyFleetTable";
import { MyFleetBreadcrumb } from "../../components/MyFleetBreadcrumb/MyFleetBreadcrumb";
import axiosHttp from "../../services/interceptor";
import { emitToasterMsg } from "../../services/toasterUtility";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const MyFleetPage = () => {
	const [refetchVesselList, setRefetchVesselList] = useState(0);
	const [exportFleetEnabled, setExportFleetEnabled] = useState(true);

	const handleExportMyFleetTable = () => {
		setExportFleetEnabled(false);
		axiosHttp
			.get(`${BASE_URL}api/MyFleet/GetMyFleetExcel`, {
				responseType: "blob",
			})
			.then((response) => {
				if (response.status === 200) {
					const blob = new Blob([response?.data], {
						type: response.headers["content-type"],
					});
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute(
						"download",
						"Enrolled-Vessel(s)-List-Export.xlsx"
					);
					document.body.appendChild(link);
					link.click();
					emitToasterMsg(
						"success",
						"Vessels",
						"Exported successfully"
					);
					document.body.removeChild(link);
					setExportFleetEnabled(true);
				}
			})
			.catch((error) => {
				setExportFleetEnabled(true);
				console.error(error.response?.data?.errorMessage);
			});
	};

	const handleRefetchVesselList = () => {
		// implemented just for demo purpose, need to find proper solution
		setRefetchVesselList(Math.random());
	};

	return (
		<div className="my-fleet-container">
			<MyFleetBreadcrumb
				refetchVesselList={handleRefetchVesselList}
				handleExportTableOnClick={handleExportMyFleetTable}
				exportFleetEnabled={exportFleetEnabled}
			/>
			<MyFleetTable
				onRefetchVesselList={refetchVesselList}
				refetchVesselList={handleRefetchVesselList}
			/>
		</div>
	);
};

export default MyFleetPage;
